export type DebugEventType =
  | 'RT_ZONE'
  | 'onEvent'
  | 'prune'
  | 'line_count'
  | 'historical_data'
  | 'historical_data_error'
  | 'validation_error'
  | 'processing_error'
  | 'connection_error'
  | 'duplicate_detected'
  | 'drive_off'
  | 'testing'
  | 'clear';

interface DebugEvent {
  type: DebugEventType;
  message: string;
  data?: any;
  formattedData?: string;
}

export class ServiceDisplayDebuggerClass {
  private addEventCallback: ((event: DebugEvent) => void) | null = null;
  private updateSummaryCallback: ((summaryMap: Map<string, any>) => void) | null = null;

  // Register callbacks from the debugger component
  registerCallbacks(
    addEvent: (event: DebugEvent) => void,
    updateSummary: (summaryMap: Map<string, any>) => void,
  ) {
    this.addEventCallback = addEvent;
    this.updateSummaryCallback = updateSummary;
  }

  // Unregister callbacks when component unmounts
  unregisterCallbacks() {
    this.addEventCallback = null;
    this.updateSummaryCallback = null;
  }

  log(type: DebugEventType, message: string, data?: any) {
    if (!this.addEventCallback) return;

    this.addEventCallback({
      type,
      message,
      data,
      formattedData: data ? this.formatEventData(data) : undefined,
    });
  }

  updateSummary(summaryMap: Map<string, any>) {
    if (!this.updateSummaryCallback) return;

    this.updateSummaryCallback(summaryMap);
  }

  private formatEventData(data: any): string {
    if (!data) return '';

    try {
      if (typeof data === 'string') {
        return data;
      }

      // Format common event structures
      if (data.evt_type === 'zone') {
        return `Zone: ${data.label} | Camera: ${data.cam_id} | Entry: ${
          data.entry_ms ? new Date(data.entry_ms).toLocaleTimeString() : 'N/A'
        } | Exit: ${data.exit_ms ? new Date(data.exit_ms).toLocaleTimeString() : 'Active'}`;
      }

      if (data.evt_type === 'line') {
        return `Line: ${data.event_line?.label || 'Unknown'} | Camera: ${
          data.cam_id
        } | Time: ${new Date(data.start_ms).toLocaleTimeString()}`;
      }

      return JSON.stringify(data, null, 2);
    } catch (_error) {
      return String(data);
    }
  }
}
